import {ADD_ATTACHMENT_LOCALLY} from "../../../reducers/settingsReducer";


export const addAttachmentLocally = (index, attachment) =>{
    return {
        type: ADD_ATTACHMENT_LOCALLY,
        payload: {index, attachment}
    }
}